<template>
  <ActionConfirmModal
    ref="modal"
    modalType="medium-modal"
    @action:afterClose="() => isModalActivated = false"
    :confirmTitle="$t('directory.msg.noPremisesAtTerminal.title')"
    :confirmBtnName="$t('action.ok')"
    :showCancelBtn="false"
  >
    <div slot="content">
      <table
        class="no-premises-at-terminal-table"
        v-if="isModalActivated"
      >
        <thead>
          <tr>
            <th
              v-for="header in noPremisesAtTerminalTableHeaders"
              :key="header.attr"
              :class="['title', header.attr]"
            >
              {{ header.title }}
            </th>
          </tr>
        </thead>

        <!-- Render Main Companies -->
        <tbody
          v-for="(company, index) in companies"
          :key="company.id"
          :class="[index % 2 === 0 ? 'row-even' : 'row-odd']"
        >
          <tr>
            <td
              v-for="header in noPremisesAtTerminalTableHeaders"
              :key="header.attr"
              :class="header.attr"
            >
              {{ company[header.attr] || header.defaultValue }}
            </td>
          </tr>
          <!-- Render Sub Companies -->
          <tr
            v-for="subCompany in company.subCompanies"
            :key="subCompany.id"
            class="sub-company"
          >
            <td
              v-for="header in noPremisesAtTerminalTableHeaders"
              :key="header.attr"
              :class="header.attr"
            >
              {{ subCompany[header.attr] || header.defaultValue }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ActionConfirmModal>
</template>

<script>
import ActionConfirmModal from '@/controls/ActionConfirmModal'
import { noPremisesAtTerminalTableHeaders } from './directoryOrderTableHelper'

export default {
  name: 'NoPremisesAtTerminalModal',
  components: {
    ActionConfirmModal,
  },
  props: {
    companies: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      isModalActivated: false,
      noPremisesAtTerminalTableHeaders,
    }
  },
  methods: {
    open () {
      this.isModalActivated = true
      this.$refs.modal.open()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/popup';
.no-premises-at-terminal-table {
  margin-top: 20px;
  margin-bottom: 0px;
  border-collapse: collapse;
  thead {
    border: 1px solid #e0e0e0;
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    background: white;
  }
  tbody {
    border-bottom: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
    tr {
      border-bottom: none;
    }
    &.row-odd tr {
      background-color: white !important;
    }
    &.row-even tr {
      background-color: #FBFBFB !important;
    }
    tr.sub-company td {
      padding-left: 2em;
    }
  }

  th, td {
    padding: 10px;
  }
  .title {
    color: #10416c;
  }
  .engName {
    width: 60%;
  }
  .premisesAtTerminal {
    width: 40%;
  }
}
</style>
